(function ($) {

    $(document).ready(function () {

        $(".read-more-link a").on("click", function () {
            if($(this).hasClass("show-more")) {
                $(this).hide();
                $(this).next().show();
                $(this).closest(".wrap-content").find(".content").addClass("open");
            } else {
                $(this).hide();
                $(this).prev().show();
                $(this).closest(".wrap-content").find(".content").removeClass("open");
            }
        });
    });

})(jQuery);